<div class="text" [ngStyle]="style" [innerHTML]="content"></div>